export const convertDataToForm = (data: any) => ({
  email: data.email,
  firstName: data.firstName,
  lastName: data.lastName,
  isTest: data.isTest,
  isAdmin: data.isAdmin,
});

export const convertDataToApi = (data: any) => ({
  firstName: data.firstName,
  lastName: data.lastName,
  isTest: data.isTest,
  isAdmin: data.isAdmin,
});
